import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ISPUICheckboxModule } from '@ispui/ng-checkbox';
import { ISPUIDropdownModule } from '@ispui/ng-dropdown';
import { ISPUISelectModule } from '@ispui/ng-select';

import { SelectComponent } from './select.component';

@NgModule({
  declarations: [SelectComponent],
  exports: [SelectComponent],
  imports: [
    CommonModule,
    FormsModule,
    ISPUISelectModule,
    // this modules required by ispui-select, even if there are no instance in component template
    ISPUIDropdownModule,
    ISPUICheckboxModule,
  ],
})
export class ISPSelectModule {}
